const NOTIFICATION_DURATION = 31536000000; // year
const CHECK_INTERVAL = 1 * 60 * 60 * 1000; // 1 hour
const RETRY_IF_IN_CALL_INTERVAL = 5 * 60 * 1000; // 5 min

export default angular
  .module('doxy.common.services.versionCheckService', [])
  .service(
    'versionCheckService',
    function (
      $interval,
      $http,
      notificationFactory,
      VideoProviderFactory,
      $timeout,
      env
    ) {
      let getVersionInterval = undefined;
      let shoNotificationTimeout = undefined;

      function showNotification() {
        if (VideoProviderFactory.activeProvider.isInCall) {
          shoNotificationTimeout = $timeout(
            showNotification,
            RETRY_IF_IN_CALL_INTERVAL
          );
        } else {
          notificationFactory.showUnsafeMessage(
            'success',
            'A new version of doxy.me is available. Please <a href="javascript: window.location.reload()">reload</a> the page to get the latest version.',
            null,
            NOTIFICATION_DURATION
          );
        }
      }
      // checking the relevance of the build
      function start() {
        if (['production', 'staging'].includes(env)) {
          const VERSION = parseInt(process.env.VERSION);
          getVersionInterval = $interval(() => {
            $http
              .get(`/version.txt?t=${new Date().getTime()}`)
              .then(function (res) {
                const newVersion = parseInt(res.data);
                if (VERSION !== newVersion) {
                  showNotification();
                  $interval.cancel(getVersionInterval);
                }
              });
          }, CHECK_INTERVAL);
        }
      }
      function stop() {
        $interval.cancel(getVersionInterval);
        $timeout.cancel(shoNotificationTimeout);
      }

      return {
        start,
        stop,
      };
    }
  ).name;
